import { Routes, BrowserRouter as Router, Route, Outlet } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import { CartProvider } from "./context/CartContext";
import { PdtsProvider, usePdts } from "./context/PdtsContext";
import { regUses } from "../axios_with_token";
import LoginProvider from "../Login/Login";

export default function OrderSystem({children}){
    const { regUse } = regUses();
    // const {loading:isLogginIn, error:loginError} = regUse(useLogin({
    //     // username: 'guest',
    //     // password: 'guest'
    //     username: 'martin',
    //     password: 'letmein'

    // }));

    return <LoginProvider
        username={"martin"}
        password={"letmein"}
    ><PdtsProvider><CartProvider>
        <Navbar></Navbar>

        <Outlet />
        {/* <Router>
            <Navbar></Navbar>
            <Routes>
                <Route
                    path="/"
                    element={<Home></Home>}
                ></Route>
                <Route
                    path="/product/:id"
                    element={<ProductDetail></ProductDetail>}
                ></Route>
                <Route
                    path="/cart"
                    element={<Cart></Cart>}
                ></Route>
                <Route
                    path="/checkout"
                    element={<Checkout></Checkout>}
                ></Route>
                <Route
                    path="*"
                    element={<div
                        className="container"
                    >
                        <h3>Page not found.</h3>
                        <a href="/" className="btn btn-primary mt-3">
                            Go Home
                        </a>
                    </div>}
                ></Route>
            </Routes>
        </Router> */}
    </CartProvider></PdtsProvider></LoginProvider>;
}